'use client';
import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';
import CommonHeader from './CommonHeader.mjs';
import { HeaderNPayMonoButton } from './HeaderNpayButton.mjs';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';
import IcQMark from '../icons/IcQMark.mjs';
import useHeaderBrandLogo from '../../hooks/useHeaderBrandLogo.mjs';
import styles from './HeaderBrandWindow.module.scss.mjs';

const cx = classNames.bind(styles);
/**
 * 서비스별 2-depth 헤더
 */
const HeaderBrandWindow = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    title,
    rightComponent,
    bgColor = 'white',
    children,
    hasTooltip = false,
    isPayApp,
    onClickTooltip,
    brandLogo = {}
  } = _ref;
  useApplyLogging('HeaderBrandWindow');
  const {
    npayLogo
  } = useHeaderBrandLogo(brandLogo);
  return /*#__PURE__*/React.createElement(CommonHeader, {
    align: "center",
    bgColor: bgColor,
    rightComponent: rightComponent,
    innerClassName: cx('article'),
    ref: ref
  }, /*#__PURE__*/React.createElement("h1", {
    className: cx('npay-wrapper')
  }, /*#__PURE__*/React.createElement(HeaderNPayMonoButton, {
    isPayApp: isPayApp,
    ...npayLogo
  })), /*#__PURE__*/React.createElement("h2", {
    className: cx('title', {
      'has-tooltip': hasTooltip
    })
  }, title, hasTooltip && ( /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('button-tooltip'),
    onClick: onClickTooltip
  }, /*#__PURE__*/React.createElement(IcQMark, {
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uD234\uD301 \uBCF4\uAE30")))), children);
});
HeaderBrandWindow.displayName = 'HeaderBrandWindow';

export { HeaderBrandWindow as default };
